import Http from "../Http/Http";

const http = new Http();
/**
 * 文件流转换为url
 * @param {blob}  //文件流
 * @param {type}  //文件类型
 */
export function BlobToURL(blob) {
  const data = new Blob([blob]);
  let url = null;
  if (window.createObjectURL !== undefined) {
    url = window.createObjectURL(data);
  } else if (window.webkitURL !== undefined) {
    url = window.webkitURL.createObjectURL(data);
  } else if (window.URL !== undefined) {
    url = window.URL.createObjectURL(data);
  }
  return url;
}

/**
 * url转换为文件流
 */
export async function URLToBlob(url) {
  const res = await http.getFileBlob(url);
  return res.data;
}

/**
 * 根据返回头获取文件名
 * @param {} resHeader
 * @returns
 */
export function getFileNameByResHeader(resHeader) {
  let fileName = "";
  const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*", "i");
  const contentDisposition = resHeader["content-disposition"];
  const result = patt.exec(contentDisposition) || [];
  if (result && result.length > 0) {
    const reg = /^["](.*)["]$/g;
    fileName = result[1].replace(reg, "$1");
  }
  fileName = decodeURI(fileName);
  return fileName;
}

/**
 * 根据文件名获取文件类型
 * @param {*} fileName
 * @returns
 */
export function getFileTypeByName(fileName) {
  const type = fileName.split(".").pop();
  return type;
}

/**根据流下载文件 */
export function downLoadFileByBlob(binaryString, resHeader) {
  const contentDisposition = resHeader["content-disposition"];
  const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*", "i");
  const result = patt.exec(contentDisposition) || [];
  let fileName = "";
  if (result && result.length > 0) {
    const reg = /^["](.*)["]$/g;
    fileName = result[1].replace(reg, "$1");
  }
  fileName = decodeURI(fileName);
  const blob = new Blob([binaryString], { type: "application/octet-stream" });
  const link = document.createElement("a");
  document.body.appendChild(link);
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  // 延时释放
  setTimeout(() => {
    window.URL.revokeObjectURL(link.href);
  }, 100);
}

export function getFileNameFromPath(path) {
  // 使用正则表达式从路径中提取文件名
  const matches = path.match(/\/([^/]+)$/);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return null;
}

const UtilFile = {
  BlobToURL,
  URLToBlob,
  getFileNameByResHeader,
  getFileTypeByName,
  downLoadFileByBlob,
  getFileNameFromPath,
};
export default UtilFile;
